module.exports = __webpack_public_path__ + "img/aiyouth_seal.6d5eeb7f.png";